export const TEAM_KEY = 'team';
export const USER_PREFERENCES_KEY = 'UserPreferences';
